import React from "react"
export const Errors = ({ formikfun, name, extraName = null }) => {
    return <>
        <div>
            {(formikfun.touched[name] || formikfun.touched[extraName]) && (formikfun.errors[name] || formikfun.errors[extraName]) ? (
                <div className="error " >{formikfun.errors[name] || formikfun.errors[extraName]}</div>
            ) : null}
        </div>
    </>
}